import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {SignService} from '../../sign/sign.service';

@Component({
  selector: 'asv-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public isCollapsed = true;
  public isLogged: boolean;
  constructor(
    private authService: AuthenticationService,
    private signService: SignService
  ) {
    this.isLogged = false;
    this.authService.isAuthenticated.subscribe((value: boolean) => {
      this.isLogged = value;
    });
  }

  ngOnInit() { }

  onLogout() {
    return this.signService.signout();
  }

}
